import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const LoadingInfo = () => {
  return (
    <div
      style={{
        gap: "20px",
        display: "flex",
        flex: "1",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        minHeight: "100vh",
      }}
    >
      <div style={{ fontWeight: "bold", fontSize: "18px" }}>Yükleniyor...</div>
      <Spin indicator={<LoadingOutlined spin />} size="large" />
    </div>
  );
};

export default LoadingInfo;
